import Title_ru_RU from '@/core/misc/decorators/Title_ru_RU';
import TYPES       from '@/core/services/Changelogs/types';

/**
 * Назначение платежа
 * Таблица: oracle.tehno_fin_payment_destination
 */
class SWPaymentDestination {

    /* Идентификатор */
    public id: number;

    /* Наименование назначения */
    @Title_ru_RU('Назначение платежа', TYPES.STRING)
    public name: string;

    /* Код назначения */
    @Title_ru_RU('Код назначения', TYPES.STRING)
    public code: string;

    static fromServer(data: any, result = new SWPaymentDestination()): SWPaymentDestination {
        result.id   = data.id;
        result.name = data.name;
        result.code = data.code;
        return result;
    }

    toString(): string {
        return this.name;
    }

}

export default SWPaymentDestination;
